<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="text-capitalize text-center">
          <span style="position:absolute;left:65px">
            <v-btn v-if="isMine" color="error" @click.stop="confirm = true">
              <v-icon left>mdi-delete</v-icon>
              {{ $t("delete") }}
            </v-btn>
          </span>
          <span style="position:absolute;left:215px">
            <v-btn
              v-if="isMine && !modifying"
              color="primary"
              @click="$emit('modify')"
            >
              <v-icon left>mdi-pencil</v-icon>
              {{ $t("update") }}
            </v-btn>
            <v-btn
              v-if="isMine && modifying"
              color="error"
              @click="$emit('cancelModify')"
            >
              {{ $t("cancel") }}
            </v-btn>
          </span>
          <span style="position:absolute;left:330px">
            <v-btn
              v-if="isMine && modifying"
              color="success"
              @click="$emit('saveModify')"
            >
              {{ $t("save") }}
            </v-btn>
          </span>

          <v-dialog v-model="confirm" max-width="590">
            <v-card>
              <v-card-title class="headline">
                Êtes-vous sûr de vouloir supprimer cette activité ?
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="grey" text @click="confirm = false">
                  {{ $t("cancel") }}
                </v-btn>
                <v-btn color="error" text @click.native="$emit('delete')">{{
                  $t("delete")
                }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <span style="position:absolute;right:65px">
            <v-bottom-sheet v-model="sheet">
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark v-bind="attrs" v-on="on">
                  <v-icon left>mdi-comment-multiple-outline</v-icon>
                  {{ comments }} {{ $t("comments") }}
                </v-btn>
              </template>

              <v-sheet class="text-center overflow-auto" height="300px">
                <v-container width="1200px">
                  <v-btn
                    class="mt-6"
                    text
                    color="error"
                    @click="sheet = !sheet"
                  >
                    {{ $t("close") }}
                  </v-btn>
                  <div class="my-3">
                    <comment-grid
                      :baseURL="firebase.databaseURL"
                      :apiKey="firebase.apiKey"
                      nodeName="customNode"
                      maxUserNameLength="30"
                      maxCommentLength="1000"
                      initialMessageLimit="11"
                      maxLineLimit="40"
                      maxShowingDepth="5"
                      background="rgba(255, 255, 255, 0)"
                      commentBackgroundColor="rgba(255, 255, 255, 1)"
                      commentTextColor="rgba(29, 33, 41, 1)"
                      userNameColor="rgba(6, 177, 183, 1)"
                    >
                    </comment-grid>
                  </div>
                </v-container>
              </v-sheet>
            </v-bottom-sheet>
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row justify="center" class="pt-4" align="center">
      <v-col class="text-center">
        <h1>
          {{ titre }}
        </h1>
      </v-col>
    </v-row>
    <div class="text-center">{{ $t("createdBy") }} {{ username }}</div>
    <div style="text-align: right">
      <span>
        <v-chip
          class="ma-2 text-center"
          :color="
            difficulte === 'Facile'
              ? 'green'
              : difficulte === 'Moyenne'
              ? 'orange'
              : 'red'
          "
          text-color="white"
        >
          {{ difficulte }}
        </v-chip>
        <span style="color:#999999">
          {{ $t("license") }}
          <i class="fab fa-creative-commons"></i>
          <i class="fab fa-creative-commons-by"></i>
          <i class="fab fa-creative-commons-sa"></i>
          <i class="fab fa-creative-commons-nc-eu"></i>
        </span>
      </span>
      <span style="position: relative;top: 25%;"> </span>
    </div>
    <v-divider></v-divider>
  </div>
</template>

<script>
const firebase = require("../../../firebase.config.js");

export default {
  name: "HeaderActivity",
  props: ["difficulte", "username", "isMine", "titre", "comments", "modifying"],
  computed: {},
  methods: {},
  data() {
    return {
      sheet: false,
      confirm: false,
      firebase: firebase.configOptions
    };
  }
};
</script>
